import * as Updates from "expo-updates";
import { Platform } from "react-native";

export type PrefetchExpoUpdateOutcome =
  | "update_downloaded"
  | "no_update"
  | "unsupported";

export type PrefetchExpoUpdateResult = {
  outcome: PrefetchExpoUpdateOutcome;
};

export const prefetchExpoUpdateAsync =
  async (): Promise<PrefetchExpoUpdateResult> => {
    if (Platform.OS === "web") {
      return {
        outcome: "unsupported",
      };
    }

    const update = await Updates.checkForUpdateAsync();

    if (!update.isAvailable) {
      return {
        outcome: "no_update",
      };
    }

    await Updates.fetchUpdateAsync();

    return {
      outcome: "update_downloaded",
    };
  };
